'use strict';

document.addEventListener('DOMContentLoaded', function () {

    const popup = document.querySelector('.wp-block-ijm-popup');

    if (!popup)
        return;

    const popupCloseButton = popup.querySelector('.wp-block-ijm-popup__close-button');
    const popupCookie = getCookie('ijm_popup');

    // Display the popup whenever no cookie is set or whenever the cookie value is different from the current popup name.
    if (!popupCookie || popupCookie !== popupCloseButton.dataset.popupName) {
        setCookie('ijm_popup', popupCloseButton.dataset.popupName, 365);
        popup.showModal();
    }

    // Close the popup on its close button click.
    popupCloseButton.addEventListener('click', function () {
        popup.close();
    });

    // Prevent the window from closing whenever the user clicks inside of it (counter the document mousedown below).
    popup.addEventListener('click', function (e) {
        e.stopPropagation();
    });

    // Close the popup whenever the user clicks outside of the dialog while opened.
    document.addEventListener('mousedown', function (event) {
        if (clickOutsidePopupWhileOpened(event, popup))
            popup.close();
    });

    function clickOutsidePopupWhileOpened(event, popup) {
        const closestPopupEventTarget = event.target.closest('.wp-block-ijm-popup__window');
        const popupWindow = popup.querySelector('.wp-block-ijm-popup__window');
        return ((!closestPopupEventTarget || closestPopupEventTarget !== popupWindow) && popup.open);
    }


    function setCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }

        document.cookie = name + "=" + (value || "") + expires + "; path=/; SameSite=Lax;" + (window.location.protocol == 'https:' ? " Secure" : "");
    }

    function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }
});